import { Button, Modal, Text } from "@mantine/core";
import { usePostApi } from "src/hooks";
import { Notification } from "src/utils/Notification";

interface Props {
  opened: boolean;
  close: () => void;
  rid: string;
  refetch: () => void;
}

const DeleteReportModal = ({ opened, close, rid, refetch }: Props) => {
  const { post } = usePostApi();
  const handleDeleteReport = async (rid: string) => {
    await post({
      request: "delete-report",
      body: { params: { rid } },
      onSuccess: () =>
        Notification(
          "Report removed",
          "Report has been deleted successfuly",
          "green",
        ),
    });
    refetch();
    close();
  };

  return (
    <Modal
      yOffset={"25dvh"}
      opened={opened}
      onClose={close}
      title="Delete report?">
      <div>
        <Text>Are you sure you wish to delete this report?</Text>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "15px",
          }}>
          <Button
            color="red"
            onClick={async () => await handleDeleteReport(rid)}>
            Yes
          </Button>
          <Button
            onClick={() => {
              close();
            }}>
            No
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteReportModal;
